var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m45.5 1.171-44.442 16.259v36.136c0 40.831 43.126 51.948 43.56 52.05l.882.213.882-.213c.434-.11 43.56-11.219 43.56-52.05v-36.136l-44.442-16.26z",
  stroke: "#fff",
  strokeWidth: 1.656
}), /*#__PURE__*/React.createElement("path", {
  d: "m38.094 73.735-17.434-17.535 5.238-5.267 12.196 12.266 27.008-27.169 5.238 5.267z",
  fill: "#ff4438",
  fillRule: "nonzero"
}));
var SvgShieldWhite = function SvgShieldWhite(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 107,
    viewBox: "0 0 91 107",
    width: 91,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShieldWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ShieldWhite.f39de266.svg";
export { ForwardRef as ReactComponent };